import { Injectable } from '@angular/core';
import { Actions, ofActionDispatched, Store } from '@ngxs/store';
import { SynchronizeVisibleNodes } from '../engine/state/engine.actions';
import { take, map, distinctUntilChanged, filter, delay } from 'rxjs/operators';
import { EngineState } from '../engine/state/engine.state';
import { ViewTreeNode } from '../engine/models/view.tree-node';
import { AddHistory } from './state/history.actions';
import { HistoryModel } from './models/history.model';
import { HistoryAction } from './models/history-action.enum';

@Injectable({
  providedIn: 'root'
})
export class HistoryService {

  constructor(
    private store: Store
  ) { }

  /**
   * Tap into the viewgraph events to record next state. Because viewgraph changes occur asynchronously from the engine,
   * we wait until the synchornize event is called to tap into and update history.
   */
  recordViewGraphHistory() {
    const viewGraph$ = this.store.select(EngineState.getViewGraph);
    viewGraph$
      .pipe(
        delay(1),
        filter(viewGraph => Object.values(viewGraph.nodes).length > 0),
        map(viewGraph => {
          const nodes = Object.values(viewGraph.nodes)
            .reduce((result, node: ViewTreeNode) => {
              result[node.id] = { id: node.id, boolState: { shown: node.boolState.shown }};
              return result;
            }, {});

          return JSON.stringify(nodes);
        }),
        distinctUntilChanged(),
        take(1)
      )
      .subscribe((viewGraph) => {
        const nodes = JSON.parse(viewGraph);
        
        this.store.dispatch(new AddHistory(
          new HistoryModel(
            HistoryAction.SetNodeVisible,
            nodes
          )
        ));
      });
  }
}
